<div class="{{ this.isDesktop ? 'view-desktop' : 'view-mobile' }}">
    <div class="result">
        <div [chart]="chart" class="evaluation-athlete-chart" style="width: 500px; height: 500px; margin: 0 auto;"></div>
        <div class="chart-more-legend">
            <ul>
                <li *ngFor="let data of legendCategories"><i class="material-icons" [style]="{'color': data.color}">signal_wifi_4_bar</i> {{data.name}}</li>
            </ul>
        </div>
    </div>
</div>
